// extracted by mini-css-extract-plugin
export default {"backdrop":"flight-request-detail_backdrop__jIu25","content":"flight-request-detail_content__XrgQl"};